module.exports = __webpack_public_path__ + "static/media/27-9.bdbc3b0d.mp3";